import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { resetResponse } from '../actions/responseActions';
import { sanitizeRoute } from '../utils/sanitize';

const useAlert = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const response = useSelector((state) => state.response);
  let timeAlert;
  useEffect(() => {
    if (response.show) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timeAlert = window.setTimeout(() => {
        const redirect = sanitizeRoute(response.redirect);
        if (redirect) {
          history.push(redirect);
        }
        dispatch(resetResponse());
      }, 3000);
    }
    return () => window.clearTimeout(timeAlert);
  }, [response]);
  return {
    response
  };
};
export default useAlert;
